import Cookies from 'js-cookie';

export const setToken = (token: string) => {
  if (document && window) {
    localStorage.setItem('access_token', token);
  }
  Cookies.set('access_token', token, { path: '/', sameSite: 'strict' });
}

export const removeToken = () => {
  if (document && window) {
    localStorage.removeItem('access_token');
  }
  Cookies.remove('access_token', { path: '/' });
}